import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { Container } from 'semantic-ui-react';

import Styles from '../Styles';
import PageBackground from '../components/PageBackground';
import { useUpdateConfig } from '../config/config.context';
import { useDesignConfig } from '../config/design.context';
import { PreviewMode } from '../config/preview.context';
import store from '../shared/Store';
import { Sponsor } from '../sponsors/Sponsor';

const SponsorPreview = () => {
  const { homeBackground, mobileHomeBackground } = useDesignConfig();
  const [sponsor, setSponsor] = useState(null);
  const updateConfig = useUpdateConfig();

  store.isPreview = true;

  useEffect(() => {
    const listener = (event) => {
      const { sponsor: sponsorData, lang } = event.data;
      if (sponsorData) {
        updateConfig({
          lang,
        });
        setSponsor(sponsorData);
      }
    };
    window.addEventListener('message', listener, false);
    return () => {
      window.removeEventListener('message', listener, false);
    };
  }, [updateConfig]);
  if (!sponsor) return null;

  return (
    <PreviewMode>
      <Provider store={store.reduxStore}>
        <Styles />
        <Container style={{ marginTop: 16 }}>
          <PageBackground image={homeBackground} mobile={mobileHomeBackground} />
          <Sponsor sponsor={sponsor} />
        </Container>
      </Provider>
    </PreviewMode>
  );
};

export default SponsorPreview;
